import { compose, hoistStatics, withProps, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import StepFiles from './StepFiles';
import { uploadActions } from '../../../../../reducers/upload';
import DocumentService from '../../../../../services/document.service';


const toggleModal = props => (e, activeStatus) => {
  e.preventDefault();
  props.setActiveModal(activeStatus);
};

const callback = props => async (formData) => {
  const { updateMulTempFileById, upload_name } = props;
  const { access_type, models, id } = formData;
  updateMulTempFileById({ id: upload_name,
    key: id,
    data: { access_type, models: models[access_type] } });
};

const updateChecked = props => (index, value) => {
  const newCheckObject = { ...props.checked };
  if (index === -1) {
    for (let i = 0; i < props.mulTempFiles[props.upload_name].length; i++) {
      newCheckObject[props.mulTempFiles[props.upload_name][i].id] = value;
    }
  }
  newCheckObject[index] = value;
  props.setChecked(newCheckObject);
};

const onEditSelect = props => (e, item) => {
  e.preventDefault();
  const { setActiveItem } = props;
  setActiveItem(item);
  toggleModal(props)(e, 1);
};

const createFiltered = (checked) => {
  const filteredIds = Object.keys(checked).filter(key => checked[key] && key !== -1)
    .map(id => parseInt(id, 10));
  return filteredIds;
};

const deleteFiles = props => (e, onRemove) => {
  e.preventDefault();
  const { checked } = props;
  const filteredIds = createFiltered(checked);
  if (filteredIds.length) {
    onRemove(e, filteredIds);
  }
};


const callbackMass = props => async (formData) => {
  const { t, checked, setChecked, updateMulTempFileById, upload_name } = props;
  const { access_type, models } = formData;
  let newModel = [];
  if (access_type !== DocumentService.ACCESS_TYPE_PUBLIC) {
    newModel = models[access_type] || [];
  }
  const filteredIds = createFiltered(checked);
  if (filteredIds.length) {
    filteredIds.forEach(fileId =>
      updateMulTempFileById({ id: upload_name,
        key: fileId,
        data: { access_type, models: newModel } }));
    setChecked({});
    toast.success(t('Access changed'));
  }
};


const changeAccess = props => (e, file) => {
  const { value } = e.target;
  const { updateMulTempFileById, upload_name } = props;
  updateMulTempFileById({ id: upload_name,
    key: file.id,
    data: { ...file, access_type: parseInt(value, 10) } });
};

const toggleModalMass = props => (e, activeStatus) => {
  e.preventDefault();
  props.setActiveModalMass(activeStatus);
};

const mapStateToProps = state => ({
  mulTempFiles: state.upload.mulTempFiles,
});

const mapDispatchToProps = {
  updateMulTempFileById: uploadActions.updateMulTempFileById,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('checked', 'setChecked', {}),
  withState('activeModal', 'setActiveModal', false),
  withState('activeItem', 'setActiveItem', null),
  withState('activeModalMass', 'setActiveModalMass', false),
  withProps(props => ({
    tempMulFiles: props.mulTempFiles[props.upload_name] || [],
  })),
  withHandlers({
    toggleModal,
    callback,
    updateChecked,
    deleteFiles,
    changeAccess,
    onEditSelect,
    callbackMass,
    toggleModalMass,
  }),
);

export default hoistStatics(enhance)(StepFiles);



// WEBPACK FOOTER //
// ./src/views/modules/documents/install/stepFiles/index.js